module.exports = [{
      plugin: require('../node_modules/gatsby-styled-components-dark-mode/gatsby-browser.js'),
      options: {"plugins":[],"light":{"secondaryColor":"#FFFAFA","primaryColor":"#06c2e3","textColor":"#071f2d","onBackgroundTextColor":"#FFFAFA","backgroundTextColor":"#1E2A31"},"dark":{"secondaryColor":"#022120","primaryColor":"#06c2e3","textColor":"#FFFAFA","onBackgroundTextColor":"#FFFAFA","backgroundTextColor":"#000000"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-157838187-3","head":false,"anonymize":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"MY-ISLAM","short_name":"MY-ISLAM","description":"Awesome website that give you local prayer time, and for the rest of the day.","lang":"en","display":"standalone","start_url":"/","background_color":"#45C569","theme_color":"#45C569","icon":"src/images/logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"3de43257111b4d3b342a56b081c4b9ab"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
